import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MainContent from "../components/MainContent";
import { withHooks } from "../hooks/withHooks";
import { useRootSelector } from "../hooks/useAppSelector";
import { contentLoad } from "../actions/contentTabActions";

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ contentLoad }, dispatch);
}

const MainContentContainer = withHooks(
  connect(null, mapDispatchToProps)(MainContent),
  useRootSelector
);

export default MainContentContainer;
